import { SHButton, SHDialog, SHStack } from "@components/design-systems";
import { AnalysisMaxShortlistedConfigs } from "@pages/platform-analysis-v2/_id/configs";

type Props = {
  open: boolean;
  numOfShortlisted?: number;
  onClose: () => void;
};

export const ShortlistedProductsExceededLimitDialog = ({
  open,
  numOfShortlisted = AnalysisMaxShortlistedConfigs.MaxProductsShortlistedAllowed,
  onClose,
}: Props) => {
  return (
    <SHDialog
      open={open}
      maxWidth={false}
      width={550}
      disableEscapeKeyDown
      disableBackdropClick
      header={`Maximum ${numOfShortlisted} platforms can be shortlisted`}
      body={`In order to proceed to the final report, please reduce your shortlist of platforms to a maximum of ${numOfShortlisted}.`}
      footer={
        <SHStack justifyContent="center" alignItems="center" direction={"row"}>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onClose}
            sx={{ width: "50%" }}
          >
            OK
          </SHButton>
        </SHStack>
      }
    />
  );
};
